<template>
  <Main></Main>
</template>

<script>
  // import HelloWorld from './components/HelloWorld.vue'
  // new NGL.Stage("viewport");
  // document.addEventListener("DOMContentLoaded", function () {
  //   var stage = new NGL.Stage("viewport");
  //   stage.loadFile("rcsb://1crn", {defaultRepresentation: true});
  // });
  import Main from "@/components/Main";

  export default {
    name: 'App',
    components: {
      Main
    }
  }
</script>

<style lang="less">
  @font-face {
      font-family: 'Open-Sans-2';  //重命名字体名
      src: url('./assets/font/Open-Sans-2.ttf');  //引入字体
      font-weight: normal;
      font-style: normal;
  }
  @font-face {
      font-family: 'FiraCode-Medium';  //重命名字体名
      src: url('./assets/font/FiraCode-Medium.ttf');  //引入字体
      font-weight: normal;
      font-style: normal;
  }
  @font-face {
      font-family: 'OpenSans-Semibold';  //重命名字体名
      src: url('./assets/font/OpenSans-Semibold.ttf');  //引入字体
      font-weight: normal;
      font-style: normal;
  }
  @font-face {
      font-family: 'OpenSans-Regular';  //重命名字体名
      src: url('./assets/font/OpenSans-Regular.ttf');  //引入字体
      font-weight: normal;
      font-style: normal;
  }

  html body{
    overflow-x: hidden;
    overflow-y: hidden;
    font-family: 'OpenSans-Semibold','Helvetica Neue',Helvetica, Arial, sans-serif !important;
    font-size: 13.5px;
    // font-family: 'Open-Sans-2'
    }

  .el-select-dropdown__list {
    margin-top: -6px !important;
    margin-bottom: 14px !important;
  }

</style>
